'use client';

import { Button } from '@/src/components/ui/button';

import React, { useState } from 'react';
import { useTranslations } from 'next-intl';

import useNavigation from '@/src/lib/hooks/useNavigation';

type Props = {
  productId: string | null;
  storeId: string | null;
  onClick?: () => void;
  btnTitle?: string;
};

const Modal = ({ productId, storeId }: Props) => {
  const { createQueryString } = useNavigation({ justUpdateUrl: true });

  const t = useTranslations('product');
  const [, setProductInfo] = useState<Props>({
    productId: null,
    storeId: null,
  });

  const handleProductInfo = () => {
    setProductInfo({ productId, storeId });
    createQueryString({ productId: `${productId}`, storeId: `${storeId}` });
  };

  return (
    <button
      className="w-full cursor-pointer border-t py-2 text-sm md:text-base"
      onClick={handleProductInfo}
    >
      {t('add-to-cart')}
    </button>
  );
};

export default Modal;
